// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Cube(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Cube" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3.22583 6.16667L12.0149 1.5L20.804 6.16667L12.0149 11.4167L3.22583 6.16667Z", fill: "currentColor" }),
            React.createElement("path", { d: "M2.63989 7.33333V17.8333L11.3899 22.5L11.429 12.5833L2.63989 7.33333Z", fill: "currentColor" }),
            React.createElement("path", { d: "M12.6399 22.5L21.3899 17.8333V7.33333L12.6008 12.5833L12.6399 22.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Cube.js.map